import Logo from "./Logo";
import Button from "./Button";

const Header = () => {
    return ( 
        <header className='absolute top-0 left-0 w-full bg-transparent'>
            <div className='container-xl flex justify-between items-center pt-9'>
                <Logo className='w-16 h-7' />      
                <div className="w-fit grid grid-cols-2 gap">
                    <Button href='/authorization' className="bg-transparent text-white">Вход</Button>
                    <Button href='/authorization'>Регистрация</Button>
                </div>          
            </div>
        </header>
    )
}

export default Header;